(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hk-object-pdp"] && !Shopify.designMode) return;
  try {
    
function initializeHeadKnobsPdp(scope) {
  scope.querySelectorAll('[data-hk-pdp]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const gallery = root.querySelector('[data-gallery]');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbnails = [...root.querySelectorAll('[data-photo-index]')];
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    let active = 0;
    function syncGallery() {
      active = Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / gallery.getBoundingClientRect().width)));
      thumbnails.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
      previous.disabled = active === 0;
      next.disabled = active === slides.length - 1;
      root.querySelector('[data-photo-count]').textContent = `${active + 1} / ${slides.length}`;
      slides.forEach((slide, i) => { slide.inert = i !== active; });
    }
    function goTo(index) {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      gallery.scrollTo({left:target * gallery.getBoundingClientRect().width, behavior:'instant'});
      syncGallery();
    }
    previous.addEventListener('click', () => goTo(active - 1));
    next.addEventListener('click', () => goTo(active + 1));
    thumbnails.forEach(button => button.addEventListener('click', () => goTo(Number(button.dataset.photoIndex))));
    gallery.addEventListener('scroll', syncGallery, {passive:true});
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    new ResizeObserver(() => { gallery.scrollTo({left:active * gallery.getBoundingClientRect().width, behavior:'instant'}); syncGallery(); }).observe(gallery);
    root.querySelector('[data-gallery-controls]').hidden = slides.length < 2;
    root.querySelector('[data-thumbnails]').hidden = slides.length < 2;
    syncGallery();
  });
}
if(document.readyState === 'loading'){document.addEventListener('DOMContentLoaded',()=>initializeHeadKnobsPdp(document));}else{initializeHeadKnobsPdp(document);}
document.addEventListener('shopify:section:load',()=>initializeHeadKnobsPdp(document));

  } catch(e) { console.error(e); }
})();
})();
